import Footer from "../Common/Footer";
import Header from "../Common/Header";

import React, { useEffect } from "react";

function Contact() {

  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
    <Header/>
    <div style={{backgroundImage:"url(" + "assets/img/bg/breadcumb-bg.jpg" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
      className="breadcumb-wrapper"
    
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Contact Us</h1>
          
        </div>
      </div>
    </div>
    <div className="space">
      <div className="container">
        <div className="row gy-4">
          <div className="col-xl-4 col-sm-6">
            <div className="contact-feature">
              <div className="box-icon">
                <img src="assets/img/icon/contact_feature_1.svg" alt="Icon" />
              </div>
              <h4 className="box-title">Phone Number</h4>
              <p className="box-text">
                <a href="tel:+91-98765 43210">+91-98765 43210</a>
              </p>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="contact-feature">
              <div className="box-icon">
                <img src="assets/img/icon/contact_feature_2.svg" alt="Icon" />
              </div>
              <h4 className="box-title">Email Address</h4>
              <p className="box-text">
               
                <a href="mailto:business@shvetdhara.com">business@shvetdhara.com</a>
              </p>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="contact-feature">
              <div className="box-icon">
                <img src="assets/img/icon/contact_feature_3.svg" alt="Icon" />
              </div>
              <h4 className="box-title">Our Address</h4>
              <p className="box-text">
              123 Dairy Excellence Park
Dehradun
              </p>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <div className="">
      <div className="container">
        <form
          action="https://html.onertheme.com/seedo/mail.php"
          method="POST"
          className="contact-form input-white ajax-contact"
        >
          <h3 className="sec-title text-center mb-35">Send Us a Massage</h3>
          <div className="row">
            <div className="form-group col-md-6">
              <input
                type="text"
                className="form-control"
                name="name"
                id="name"
                placeholder="Your Name"
              />{" "}
              <i className="fal fa-user" />
            </div>
            <div className="form-group col-md-6">
              <input
                type="email"
                className="form-control"
                name="email"
                id="email"
                placeholder="Email Address"
              />{" "}
              <i className="fal fa-envelope" />
            </div>
            <div className="form-group col-md-6">
              <input
                type="tel"
                className="form-control"
                name="number"
                id="number"
                placeholder="Phone Number"
              />{" "}
              <i className="fal fa-phone" />
            </div>
            <div className="form-group col-md-6">
              <input
                type="text"
                className="form-control"
                name="subject"
                id="subject"
                placeholder="Subject"
              />{" "}
              <i className="fal fa-file-invoice" />
            </div>
            <div className="form-group col-12">
              <textarea
                name="message"
                id="message"
                cols={30}
                rows={3}
                className="form-control"
                placeholder="Your Message"
                defaultValue={""}
              />{" "}
              <i className="fal fa-pencil" />
            </div>
            <div className="form-btn col-12 text-center">
              <button className="ot-btn">
                Send Message
                <i className="fas fa-chevrons-right ms-2" />
              </button>
            </div>
          </div>
          <p className="form-messages mb-0 mt-3" />
        </form>
      </div>
    </div>
    <div className="" id="mapSec">
      <div className="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3426.339165570564!2d75.19265457439218!3d30.821161281355725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a09f5408e00d9%3A0xc096d013863f8fdf!2sChadha%20Mall!5e0!3m2!1sen!2sin!4v1738069742807!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
        />
      </div>
    </div>
  
    <Footer />
  </>
  
  );
}

export default Contact;
